import styled, {css, DefaultTheme} from 'styled-components'

export const StyledPrivateLayout = styled.div`
    min-height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    overflow: hidden;
`

export const StyledMain = styled.div(
    ({theme: {spacing}}: {theme: DefaultTheme}) => css`
        overflow-y: auto;
        height: 100%;
        padding: ${spacing * 6}px 0;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 5}px;
    `
)
